export default {
    tenant: '0dca57f1-8ca8-4d39-b81d-345f03cbb5e7',
    clientId: '7b8d98d9-60a7-4c82-99cb-e0a1ee4c1c84',
    redirecturl: process.env.VUE_APP_OAUTH_URL,
    //authority: 'https://login.microsoftonline.com/0dca57f1-8ca8-4d39-b81d-345f03cbb5e7',
    graphscopes: {
        scopes: ["https://graph.microsoft.com/User.Read"]
    },
    graphendpoint: 'https://graph.microsoft.com/v1.0/me',
    appinsightsid: '',
    cacheLocation: 'localStorage'
}